// Calculating ambulance handover time
import {isNaN} from 'lodash';
import moment from 'moment';
import config from '../app/config';

export const calculateArrivalDate = (currentPatient) => {
    if (currentPatient?.admission) {
        let admission = moment(currentPatient.admission?.startDate);
        admission.set('second', 0).set('millisecond', 0);

        if (currentPatient?.ambulanceHandover?.when) {
            const ambulanceTime = moment(currentPatient.ambulanceHandover?.when, config.defaultDateTimeFormat).isValid()
                ? moment(currentPatient.ambulanceHandover?.when, config.defaultDateTimeFormat)
                : moment(currentPatient.ambulanceHandover?.when);

            const duration = moment(ambulanceTime).diff(admission, 'minute');

            if (!isNaN(duration) && duration <= 15) {
                return ambulanceTime;
            } else {
                admission.add(15, 'minutes');
                return admission;
            }
        }
        return admission;
    }
};


///////////////////////////////////////////
///////             AGE             ///////
///////////////////////////////////////////
const PAED_UPPER_BOUND = 18;

export const calculatePatientAge = (currentPatient) => {
    if (!currentPatient?.patient?.dob) return "Unk";

    const now = moment();

    return now.diff(currentPatient?.patient?.dob, 'years');
}

export const isPatientPaed = (currentPatient) => {
    if (!currentPatient?.patient?.dob) return false;

    const ptAge = calculatePatientAge(currentPatient);

    return ptAge < PAED_UPPER_BOUND;
}

/**
 * Retrieves the start date of a patient's admission based on the type of attendance.
 *
 * This function determines the correct start date for the admission:
 * - If the attendance type is 'E' (Emergency), it returns the `startDate` as the admission start date.
 * - For other attendance types, it returns the `spellStartDate` if available; otherwise, it defaults to `startDate`.
 *
 * The start date is returned as a moment.js object for easy manipulation and formatting.
 *
 * @param {Object} admission - The admission object containing details about the patient's stay.
 * @param {string} admission.attendanceType - The type of attendance ('E' for emergency, others for non-emergency).
 * @param {string} admission.startDate - The primary start date of the admission.
 * @param {string} [admission.spellStartDate] - The start date of the spell, if applicable.
 *
 * @returns {Object} A moment object representing the start date of the admission.
 *
 * @example
 * // Get the admission start date for an emergency attendance.
 * const startDate = getAdmissionStartDate({
 *   attendanceType: 'E',
 *   startDate: '2023-08-23T14:00:00Z'
 * });
 *
 * // Get the admission start date for a non-emergency attendance with a spell start date.
 * const startDate = getAdmissionStartDate({
 *   attendanceType: 'I',
 *   startDate: '2023-08-23T14:00:00Z',
 *   spellStartDate: '2023-08-22T10:00:00Z'
 * });
 */
export const getAdmissionStartDate = (admission) => {
    try {
        if (!admission) return moment();
        if (admission.attendanceType === 'E') {
            return moment(admission.startDate);
        } else {
            return admission.spellStartDate ? moment(admission.spellStartDate) : moment(admission.startDate);
        }
    } catch (e) {
        console.error(e);
        return null;
    }

};